// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Núcleo: componentes comunes, navegación, acceso, inicio y glosario de términos compartidos.
export default {
  // Glosario (nombres de productos y términos que se repiten en toda la plataforma)
  'Inicio': 'Home',
  'Personas': 'People',
  'Persona': 'Person',
  'Servicios': 'Services',
  'Check-Ins': 'Check-Ins',
  'Donaciones@@módulo': 'Giving',
  'Donaciones': 'Donations',
  'Grupos': 'Groups',
  'Calendario': 'Calendar',
  'Inscripciones': 'Registrations',
  'Chat': 'Chat',
  'Páginas': 'Pages',
  'Administración': 'Administration',
  'Campus': 'Campus',
  'Todos los campus': 'All campuses',
  'Todos': 'All',
  'Guardar': 'Save',
  'Cancelar': 'Cancel',
  'Eliminar': 'Delete',
  'Editar': 'Edit',
  'Quitar': 'Remove',
  'Agregar': 'Add',
  'Crear': 'Create',
  'Buscar': 'Search',
  'Cerrar': 'Close',
  'Confirmar': 'Confirm',
  'Archivar': 'Archive',
  'Volver': 'Back',
  'Nombre': 'First name',
  'Apellido': 'Last name',
  'Correo electrónico': 'Email',
  'Contraseña': 'Password',

  // Componentes comunes
  'Cargando…': 'Loading…',
  'Ocurrió un error': 'Something went wrong',
  '¿Seguro?': 'Are you sure?',
  'Anterior': 'Previous',
  'Siguiente': 'Next',
  'Página {page} de {pages}': 'Page {page} of {pages}',
  'Buscar por nombre, correo o teléfono': 'Search by name, email or phone',
  'Buscando…': 'Searching…',
  'Sin resultados': 'No results',
  'Elige un campus…': 'Choose a campus…',
  'Gráfica de barras': 'Bar chart',
  '{label} año anterior: {value}': '{label} previous year: {value}',
  'No hay conexión con el servidor. Revisa tu internet e intenta de nuevo.': 'Can’t reach the server. Check your internet connection and try again.',
  'Error {status}': 'Error {status}',
  'Cambiar idioma': 'Change language',

  // Navegación
  'Iglesia': 'Church',
  'Mis tareas': 'My tasks',
  'Portal de miembros': 'Member portal',
  'Abrir kiosko': 'Open kiosk',
  'Configuración': 'Settings',
  'Cambiar de sección': 'Switch section',
  'Secciones de {name}': '{name} sections',
  'Notificaciones': 'Notifications',
  'Salir': 'Sign out',
  'Portal': 'Portal',
  'Mi programación': 'My schedule',
  'Donar': 'Give',
  'Mensajes': 'Messages',
  'Avisos': 'Notifications',
  'Mi perfil': 'My profile',
  'Panel': 'Staff app',
  'Página no encontrada': 'Page not found',
  'La dirección no existe o fue movida.': 'This address doesn’t exist or has moved.',
  'Volver al inicio': 'Back to home',

  // Acceso y cuenta
  'Iniciar sesión': 'Sign in',
  'Inicia sesión': 'Sign in',
  'Entrar': 'Sign in',
  'Verificar': 'Verify',
  'Verificación en dos pasos': 'Two-step verification',
  '¿Primera vez?': 'First time here?',
  'Crea tu cuenta': 'Create your account',
  'Código': 'Code',
  '¿Olvidaste tu contraseña?': 'Forgot your password?',
  'Recuperar contraseña': 'Reset password',
  'Activar mi cuenta': 'Activate my account',
  'Volver a iniciar sesión': 'Back to sign in',
  'Si el correo está registrado, te enviamos un enlace. Revisa tu bandeja de entrada (y la de spam).': 'If that email is registered, we sent you a link. Check your inbox (and your spam folder).',
  'Te enviaremos un enlace para crear una contraseña nueva.': 'We’ll email you a link to create a new password.',
  'Si la iglesia ya tiene tus datos pero nunca creaste una contraseña, te enviaremos un enlace para activarla.': 'If the church already has your information but you never created a password, we’ll email you a link to activate your account.',
  'Enviar enlace': 'Send link',
  '¿Nunca creaste una contraseña? Activa tu cuenta': 'Never created a password? Activate your account',
  'Ya tengo cuenta: recuperar contraseña': 'I already have an account: reset password',
  'Las contraseñas no coinciden': 'The passwords don’t match',
  'Enlace incompleto': 'Incomplete link',
  'El enlace no tiene el código necesario. Pide uno nuevo.': 'This link is missing its code. Request a new one.',
  'Pedir otro enlace': 'Request another link',
  'Nueva contraseña': 'New password',
  'Activa tu cuenta': 'Activate your account',
  'Usa al menos 10 caracteres, con letras y números.': 'Use at least 10 characters, with letters and numbers.',
  'Tu contraseña se cambió. Ya puedes iniciar sesión.': 'Your password was changed. You can sign in now.',
  'Confirmar contraseña': 'Confirm password',
  'Configuración inicial': 'Initial setup',
  'Solo se hace una vez. Podrás cambiar todo después en Administración.': 'You only do this once. You can change everything later in Administration.',
  'Nombre de la iglesia': 'Church name',
  'Zona horaria': 'Time zone',
  'Ejemplo: America/New_York, America/Chicago, America/Los_Angeles': 'Example: America/New_York, America/Chicago, America/Los_Angeles',
  'Campus (nombre y código corto)': 'Campuses (name and short code)',
  'Campus {n}': 'Campus {n}',
  '+ Agregar campus': '+ Add campus',
  'Administrador general': 'Super admin',
  'Correo': 'Email',
  'Al menos 10 caracteres, con letras y números.': 'At least 10 characters, with letters and numbers.',
  'Crear la plataforma': 'Create the platform',
  'Crear cuenta': 'Create account',
  'Para ver tu programación, donar, inscribirte y unirte a grupos.': 'To see your schedule, give, register for events and join groups.',
  '¿Ya tienes cuenta?': 'Already have an account?',
  '¿La iglesia ya tiene tus datos?': 'Does the church already have your information?',
  'Actívala': 'Activate it',
  '¿A qué campus asistes?': 'Which campus do you attend?',
  'Todavía no sé': 'Not sure yet',
  'Mi cuenta': 'My account',
  'Cambiar contraseña': 'Change password',
  'Contraseña actual': 'Current password',
  'Contraseña actualizada. Se cerraron tus otras sesiones.': 'Password updated. Your other sessions were signed out.',
  'Verificación en dos pasos activada': 'Two-step verification turned on',
  'Verificación en dos pasos desactivada': 'Two-step verification turned off',
  'Activada. Al iniciar sesión te pediremos un código de tu aplicación.': 'On. When you sign in we’ll ask for a code from your app.',
  'Desactivar': 'Turn off',
  'Escanea el código con Google Authenticator, Microsoft Authenticator o similar. Si no puedes escanear, escribe la clave manualmente.': 'Scan the code with Google Authenticator, Microsoft Authenticator or a similar app. If you can’t scan it, type the key manually.',
  'Código QR para la aplicación de autenticación': 'QR code for the authenticator app',
  'Código de 6 dígitos': '6-digit code',
  'Activar': 'Turn on',
  'Protege tu cuenta con un código temporal además de tu contraseña. Recomendado para todo el personal.': 'Protect your account with a temporary code in addition to your password. Recommended for all staff.',
  'Configurar': 'Set up',

  // Inicio y tareas
  'Buenos días': 'Good morning',
  'Buenas tardes': 'Good afternoon',
  'Buenas noches': 'Good evening',
  '{greet}, {name}': '{greet}, {name}',
  '+ Agregar widget': '+ Add widget',
  'Agregar widget': 'Add widget',
  'Tipo de widget': 'Widget type',
  'Solo verás datos de los módulos a los que tienes acceso.': 'You’ll only see data from the modules you have access to.',
  'Asistencia (Check-Ins)': 'Attendance (Check-Ins)',
  'Personas programadas': 'People scheduled',
  'Pronóstico de planes': 'Plans forecast',
  'Equipos del próximo plan': 'Teams for the next plan',
  'Cumpleaños': 'Birthdays',
  'Aniversarios': 'Anniversaries',
  'Perfiles nuevos': 'New profiles',
  'Donaciones por mes': 'Donations by month',
  'Lotes abiertos': 'Open batches',
  'Registros por domingo': 'Check-ins by Sunday',
  'Asistencia a grupos': 'Group attendance',
  'Próximos eventos': 'Upcoming events',
  'Aprobaciones pendientes': 'Pending approvals',
  'Inscripciones recientes': 'Recent registrations',
  'Notas': 'Notes',
  'Enlaces rápidos': 'Quick links',
  'Confirmado': 'Confirmed',
  'Confirmados': 'Confirmed',
  'Sin responder': 'Unconfirmed',
  'Declinado': 'Declined',
  'Pendientes': 'Pending',
  'Por cubrir': 'Needed',
  'Este mes · comparado con el mismo mes del año pasado (en curso)': 'This month · compared with the same month last year (to date)',
  'Este año': 'This year',
  'Año anterior': 'Last year',
  'Escribe aquí tus notas…': 'Write your notes here…',
  'Guardado': 'Saved',
  'Guardando…': 'Saving…',
  'Agrega enlaces a sitios que usas seguido.': 'Add links to sites you use often.',
  'Listo': 'Done',
  'Editar enlaces': 'Edit links',
  'No tienes programación próxima.': 'You’re not scheduled anytime soon.',
  'Responder solicitudes →': 'Respond to requests →',
  'No hay planes próximos.': 'No upcoming plans.',
  'Abrir': 'Open',
  '{c} conf. · {u} pend. · {open} por cubrir': '{c} conf. · {u} pend. · {open} needed',
  'Nadie en los próximos {n} días.': 'No one in the next {n} days.',
  '{n} año': '{n} year',
  '{n} años': '{n} years',
  'No hay lotes abiertos.': 'No open batches.',
  'Aún no hay registros.': 'No check-ins yet.',
  'No hay eventos próximos.': 'No upcoming events.',
  'Revisar aprobaciones →': 'Review approvals →',
  'Sin inscripciones recientes.': 'No recent registrations.',
  'No tienes tareas pendientes.': 'You have no open tasks.',
  '{n} vencida': '{n} overdue',
  '{n} vencidas': '{n} overdue',
  'Ver todas →': 'See all →',
  'Subir': 'Move up',
  'Bajar': 'Move down',
  'Actualizar': 'Refresh',
  'Tareas': 'Tasks',
  '+ Nueva lista': '+ New list',
  'Listas': 'Lists',
  'Compartida': 'Shared',
  'Sin listas': 'No lists',
  'Crea tu primera lista de tareas.': 'Create your first task list.',
  'Nueva tarea': 'New task',
  'Vence': 'Due',
  'Repetir': 'Repeat',
  'No se repite': 'Does not repeat',
  'Cada día': 'Every day',
  'Cada semana': 'Every week',
  'Cada mes': 'Every month',
  'Cada año': 'Every year',
  'Asignada a': 'Assigned to',
  'Cambiar': 'Change',
  'Asignar a (opcional)': 'Assign to (optional)',
  'Completadas': 'Completed',
  'Todo al día': 'All caught up',
  'Nada completado aún': 'Nothing completed yet',
  'Se creó la siguiente para el {date}': 'The next one was created for {date}',
  'Nueva lista': 'New list',
  'Compartida con el personal': 'Shared with staff',
  "Sin verificación en dos pasos": "No two-step verification",
  "Confirma en persona que es {name}. Se cerrarán sus sesiones y al volver a entrar tendrá que activar la verificación de nuevo con su teléfono nuevo.": "Confirm in person that this is {name}. Their sessions will be closed, and when they sign in again they’ll have to turn on verification again with their new phone.",
  "Verificación restablecida": "Verification reset",
  "Restablecer verificación": "Reset verification",
  "Exigir verificación en dos pasos a todo el personal": "Require two-step verification for all staff",
  "En producción siempre se exige.": "Always required in production.",
  "Solo se puede quitar en una instalación de demostración o de pruebas; en producción siempre se exige.": "Can only be turned off in a demo or test installation; it’s always required in production.",
  "Te queda {n} código de respaldo.": "You have {n} backup code left.",
  "Te quedan {n} códigos de respaldo.": "You have {n} backup codes left.",
  "Código actual de tu aplicación": "Current code from your app",
  "Generar códigos de respaldo nuevos": "Generate new backup codes",
  "Es obligatoria para el personal. Si pierdes tu teléfono y tus códigos de respaldo, pide a un administrador que la restablezca.": "It’s required for staff. If you lose your phone and your backup codes, ask an administrator to reset it.",
  "Usaste un código de respaldo. Te queda {n}; genera nuevos en Mi cuenta.": "You used a backup code. You have {n} left; generate new ones in My account.",
  "Usaste un código de respaldo. Te quedan {n}; genera nuevos en Mi cuenta.": "You used a backup code. You have {n} left; generate new ones in My account.",
  "Escribe el código de 6 dígitos de tu aplicación de autenticación. Si perdiste tu teléfono, usa uno de tus códigos de respaldo.": "Enter the 6-digit code from your authenticator app. If you lost your phone, use one of your backup codes.",
  "Códigos de respaldo (cada uno sirve una sola vez)": "Backup codes (each one works only once)",
  "Guarda estos códigos en un lugar seguro. Si pierdes tu teléfono, cada uno te deja entrar una vez. No los volverás a ver.": "Keep these codes somewhere safe. If you lose your phone, each one lets you sign in once. You won’t see them again.",
  "Códigos de respaldo": "Backup codes",
  "Copiados": "Copied",
  "Descargar": "Download",
  "Ya los guardé": "I’ve saved them",
  "Activa la verificación en dos pasos": "Turn on two-step verification",
  "Para proteger los datos de las familias y los niños, todo el personal entra con su contraseña y un código de su teléfono. Toma un minuto.": "To protect families’ and children’s data, all staff sign in with their password and a code from their phone. It takes a minute.",
  "Ir al portal de miembros": "Go to the member portal",
  "Cerrar sesión": "Sign out",
  "Respaldos": "Backups",
  "Copia cifrada de la base de datos y de los archivos adjuntos, cada noche.": "An encrypted copy of the database and attachments, every night.",
  "Simulacro en curso…": "Restore drill in progress…",
  "Probar restauración": "Test restore",
  "Respaldo en curso…": "Backup in progress…",
  "Respaldar ahora": "Back up now",
  "Los respaldos automáticos están desactivados. Configura BACKUP_ENCRYPTION_KEY en el servidor (ver README, sección Respaldos).": "Automatic backups are off. Set BACKUP_ENCRYPTION_KEY on the server (see the README, Backups section).",
  "El último respaldo falló ({date}): {error}": "The last backup failed ({date}): {error}",
  "No hay un respaldo de las últimas 36 horas.": "There's no backup from the last 36 hours.",
  "Los respaldos solo están en este servidor. Configura BACKUP_COPY_COMMAND para copiarlos a otro lugar: si el servidor se pierde, se pierden con él.": "Backups are only on this server. Set BACKUP_COPY_COMMAND to copy them somewhere else: if the server is lost, they're lost with it.",
  "Todos los días a partir de las {hour}:00 ({tz}).": "Every day from {hour}:00 ({tz}).",
  "Se conservan: uno por día de los últimos {daily} días, uno por semana de las últimas {weekly} semanas y uno por mes de los últimos {monthly} meses.": "Kept: one per day for the last {daily} days, one per week for the last {weekly} weeks and one per month for the last {monthly} months.",
  "Cada respaldo se copia fuera del servidor.": "Each backup is copied off the server.",
  "La copia fuera del servidor no incluye los archivos adjuntos. Agrega $BACKUP_FILES_DIR a BACKUP_COPY_COMMAND: si el servidor se pierde, los archivos se pierden con él.": "The off-server copy doesn't include attachments. Add $BACKUP_FILES_DIR to BACKUP_COPY_COMMAND: if the server is lost, the files are lost with it.",
  "Archivos guardados: {count} ({size}). Cada uno se guarda una sola vez, aunque lo usen varios respaldos.": "Files saved: {count} ({size}). Each one is stored only once, even if several backups use it.",
  "Archivos leídos sin daños: {count}.": "Files read without damage: {count}.",
  "Sin copia fuera del servidor.": "No copy off the server.",
  "Para restaurar hacen falta BACKUP_ENCRYPTION_KEY y DATA_ENCRYPTION_KEY. Guárdalas fuera del servidor (por ejemplo, en un gestor de contraseñas).": "Restoring needs BACKUP_ENCRYPTION_KEY and DATA_ENCRYPTION_KEY. Keep them off the server (for example, in a password manager).",
  "Último simulacro de restauración": "Last restore drill",
  "Todavía no se ha probado restaurar un respaldo. Hazlo al menos una vez al mes.": "No backup has been test-restored yet. Do it at least once a month.",
  "{date}: se restauró {file} en una base temporal; {tables} tablas y {rows} filas coinciden.": "{date}: {file} was restored into a temporary database; {tables} tables and {rows} rows match.",
  "No coinciden: {list}": "Don't match: {list}",
  "{n} respaldo guardado": "{n} backup saved",
  "{n} respaldos guardados": "{n} backups saved",
  "Todavía no hay respaldos": "No backups yet",
  "Archivo": "File",
  "Tamaño": "Size",
  "Más reciente": "Latest",
  "Campus del widget": "Widget campuses",
  "Sin ninguno marcado, el widget muestra todos los campus que puedes ver.": "With none checked, the widget shows every campus you can see.",
  "Elegir campus": "Choose campuses",
  "Exportar CSV": "Export CSV",
  "Subir archivos": "Upload files",
  "+ Enlace": "+ Link",
  "Sin archivos": "No files",
  "¿Quitar «{name}»?": "Remove “{name}”?",
  "Agregar enlace": "Add link",
  "Video de referencia": "Reference video",
  "Dirección (https://…)": "Address (https://…)",
  "Cambiar nombre": "Rename",
  "Descripción (opcional)": "Description (optional)",
  "fondos insuficientes": "insufficient funds",
  "la tarjeta está vencida": "the card is expired",
  "algún dato de la tarjeta no es correcto": "some card details are incorrect",
  "el banco pide confirmar el pago": "the bank needs you to confirm the payment",
  "el banco no autorizó el débito de la cuenta": "the bank didn’t authorize the account debit",
  "el banco rechazó el pago": "the bank declined the payment",
  "Errores": "Errors",
  "Servidor": "Server",
  "Pantalla": "Screen",
  "Tarea": "Task",
  "Proceso": "Process",
  "Envío de correos, SMS y WhatsApp": "Email, SMS and WhatsApp delivery",
  "Limpieza de sesiones": "Session cleanup",
  "Recordatorios de Servicios": "Services reminders",
  "Respaldo diario": "Daily backup",
  "Limpieza de errores antiguos": "Old error cleanup",
  "Cobro de donaciones recurrentes": "Recurring gift charges",
  "Eventos de Stripe": "Stripe events",
  "Alerta de prueba enviada a los administradores generales.": "Test alert sent to the general administrators.",
  "Errores del servidor, de las pantallas y de las tareas programadas. Cada error repetido aparece una vez con su conteo. Los administradores generales reciben un correo cuando aparece uno nuevo.": "Errors from the server, the screens and the scheduled tasks. Each repeated error shows up once with its count. General administrators get an email when a new one appears.",
  "Enviar alerta de prueba": "Send test alert",
  "{n} tarea programada está fallando.": "{n} scheduled task is failing.",
  "{n} tareas programadas están fallando.": "{n} scheduled tasks are failing.",
  "Tareas programadas": "Scheduled tasks",
  "Todavía no ha corrido ninguna tarea": "No task has run yet",
  "Último éxito": "Last success",
  "Bien": "OK",
  "{n} falla seguida": "{n} failure in a row",
  "{n} fallas seguidas": "{n} failures in a row",
  "Mostrar": "Show",
  "Sin resolver": "Unresolved",
  "Resueltos": "Resolved",
  "Marcar todos como resueltos": "Mark all as resolved",
  "Sin errores pendientes": "No pending errors",
  "Sin errores": "No errors",
  "Todo en orden.": "All good.",
  "última {when}": "last {when}",
  "primera {date}": "first {date}",
  "Resuelto": "Mark resolved",
  "Reabrir": "Reopen",
  "Cuándo": "When",
  "Dónde": "Where",
  "Cuenta": "Account",
  "Navegador": "Browser",
  "Para recibir avisos también fuera del correo, configura ALERT_WEBHOOK_URL (Slack, Discord o Google Chat) y ALERT_EMAILS en el servidor. Para saber si el servidor se cae, usa un monitor externo (por ejemplo UptimeRobot) que revise /api/health cada 5 minutos.": "To get alerts outside email too, set ALERT_WEBHOOK_URL (Slack, Discord or Google Chat) and ALERT_EMAILS on the server. To know if the server goes down, use an external monitor (for example UptimeRobot) that checks /api/health every 5 minutes.",
  "Algo salió mal en esta pantalla": "Something went wrong on this screen",
  "El equipo ya recibió el aviso. Puedes recargar la página o volver al inicio; lo que ya guardaste no se perdió.": "The team has already been notified. You can reload the page or go back home; anything you already saved wasn’t lost.",
  "Recargar": "Reload",
  "Ir al inicio": "Go home",
} satisfies Record<string, string>;
